<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">
    <app-autocomplete
      class="w-full block"
      label="¿Cuál es tu fondo de pensiones?"
      placeholder="Ej. Previsora"
      [items]="pensionFunds"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.fonpen"
      (valueChange)="setFonpen($event)">
    </app-autocomplete>

    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            [timeoutSeconds]="0.6"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    @for (item of dataSelected(); track $index) {
        <app-selected class="w-full"
            [config]="item"
            (selectValue)="handleValue($event)"
        ></app-selected>
    }

    <app-autocomplete
      label="¿Cuál es tu profesión?"
      [items]="codpros"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.codpro"
      (valueChange)="form.patchValue({ codpro: $event })">
    </app-autocomplete>

</form>
